import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslationItem } from '@hazmatsuite-next/ui';
import { LanguageService } from 'libs/ui/src/lib/services/language.service';
import { Observable } from 'rxjs';
import { AddressModel } from '../models/address.model';
import { EditAddressModel } from '../models/edit-address.model';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private http: HttpClient, private languageService: LanguageService) { }

  getList(): Observable<AddressModel[]> {
    return this.http.get<AddressModel[]>(`${this.languageService.getLanguage()}/Address/List`);
  }

  getAddress(id: number): Observable<EditAddressModel> {
    const httpParams = new HttpParams().set('addressId', id);
    return this.http.get<EditAddressModel>(`${this.languageService.getLanguage()}/Address/Get`, { params: httpParams });
  }

  getCountries(): Observable<TranslationItem[]> {
    return this.http.get<TranslationItem[]>(`${this.languageService.getLanguage()}/Address/Countries`);
  }

  saveAddress(isEdit: boolean, data: EditAddressModel): Observable<void> {
    return this.http.post<void>(`${this.languageService.getLanguage()}/Address/Set`, data);
  }

  selectAddress(data: Partial<EditAddressModel>): Observable<void> {
    return this.http.post<void>(`${this.languageService.getLanguage()}/Address/Select`, data);
  }
}
